import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import Localizer from "@Scripts/Common/Localizer";

@Component({ name: "YZbLUcRUForm" })
export default class YZbLUcRUForm extends Vue {
    public localizer: any = Localizer;
    public isSuccess: boolean = false;
    public isLoading: boolean = false;
    public countries: any[] = [];
    //public raceCountries: any[] = [];
    public ridingGearMXSizes: any[] = [];
    public paddockBlueClothingsSizes: any[] = [];
    public genders: any[] = [];
    public landingFormSubmit: any = {
        cupType: null,
        riderCountry: null,
        riderAge: null,
        endMonthFIMChampionship: null,
        riderPaddockClothingSize: null,
        riderMXJerseySize: null,
        riderMXPantsSize: null,
        riderMXGlovesSize: null,
        riderGender: null,
        //raceCountry: null
    };
    public validationErrors: any[] = [];

    @Prop() readonly recaptchaSiteKey: string;
    @Prop() readonly culture: string;

    get routes() {
        return (<any>window).App.routes;
    }

    public async created() {
        this.countries = (await Axios.post(this.routes.Landing_YZbLUcRU_GetCountries, null)).data;
        //this.raceCountries = (await Axios.post(this.routes.Landing_YZbLUcRU_GetRaceCountries, null)).data;
        this.ridingGearMXSizes = (await Axios.post(this.routes.Landing_YZbLUcRU_GetRidingGearMXSizes, null)).data;
        this.paddockBlueClothingsSizes = (await Axios.post(this.routes.Landing_YZbLUcRU_GetPaddockBlueClothingsSizes, null)).data;
        this.genders = (await Axios.post(this.routes.Landing_YZbLUcRU_GetGenders, null)).data;
    }

    public mounted() {
        let recaptchaScript = document.createElement("script");
        recaptchaScript.setAttribute("src", "https://www.google.com/recaptcha/api.js");
        document.head.appendChild(recaptchaScript);
    }

    public async submitForm() {
        FormHelper.removeFocus();
        this.validationErrors = [];
        this.isLoading = true;

        try {
            await Axios.post(this.routes.Landing_YZbLUcRU_Home, this.landingFormSubmit, { headers: { "RecaptchaVerificationToken": (<any>window).grecaptcha.getResponse() } });
            this.isSuccess = true;
        } catch (error) {
            if (error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }

            (<any>window).grecaptcha.reset();
        }

        this.isLoading = false;
    }

    public yamahaRacing() {
        (<any>window).location = "https://www.yamaha-racing.com/";
    }

    public setPrivacyStatement() {
        let privacyStatement = "https://www.yamaha-motor.eu/gb/en/privacy-policy/";

        switch (this.culture) {
            case "be-FR":
                privacyStatement = "https://www.yamaha-motor.eu/be/fr/privacy-policy/"
                break;
            case "be-NL":
                privacyStatement = "https://www.yamaha-motor.eu/be/nl/privacy-policy/"
                break;
            case "nl-NL":
                privacyStatement = "https://www.yamaha-motor.eu/nl/nl/privacy-policy/";
                break;
            case "es-ES":
                privacyStatement = "https://www.yamaha-motor.eu/es/es/privacy-policy/";
                break;
            case "fr-FR":
                privacyStatement = "https://www.yamaha-motor.eu/fr/fr/privacy-policy/";
                break;
            case "it-IT":
                privacyStatement = "https://www.yamaha-motor.eu/it/it/privacy/privacy-policy/";
                break;
            case "de-DE":
                privacyStatement = "https://www.yamaha-motor.eu/de/de/privacy/privacy-policy/";
                break;
            case "sv-SE":
                privacyStatement = "https://www.yamaha-motor.eu/se/sv/privacy/privacy-policy/";
                break;
            case "da-DK":
                privacyStatement = "https://www.yamaha-motor.eu/dk/da/privacy/privacy-policy/";
                break;
            case "fi-FI":
                privacyStatement = "https://www.yamaha-motor.eu/fi/fi/privacy-policy/";
                break;
            case "nn-NO":
                privacyStatement = "https://www.yamaha-motor.eu/no/nb/privacy-policy/";
                break;
            case "de-AT":
                privacyStatement = "https://www.yamaha-motor.eu/at/de/privacy-policy/";
                break;
            case "fr-BE":
                privacyStatement = "https://www.yamaha-motor.eu/be/fr/privacy-policy/";
                break;
            case "nl-BE":
                privacyStatement = "https://www.yamaha-motor.eu/be/nl/privacy-policy/";
                break;
            case "it-CH":
                privacyStatement = "https://www.yamaha-motor.eu/it/it/privacy/privacy-policy/";
                break;
            case "de-CH":
                privacyStatement = "https://www.yamaha-motor.eu/ch/de/privacy-policy/";
                break;
            case "fr-CH":
                privacyStatement = "https://www.yamaha-motor.eu/ch/fr/privacy-policy/";
                break;
            case "hr-HR":
                privacyStatement = "https://www.yamaha-motor.eu/hu/hu/privacy-policy/";
                break;
            case "el-GR":
                privacyStatement = "https://www.yamaha-motor.eu/gr/el/privacy-policy/";
                break;
            case "pt-PT":
                privacyStatement = "https://www.yamaha-motor.eu/pt/pt/privacy-policy/";
                break;
            case "tr-TR":
                privacyStatement = "https://www.yamaha-motor.eu/tr/tr/privacy-policy/";
                break;
            case "uk-UA":
                privacyStatement = "https://www.yamaha-motor.eu/ua/uk/privacy-policy/";
                break;
        }

        return privacyStatement;
    }

    public setTermsAndCondition() {
        let termsAndCondition = "https://www.yamaha-racing.com/content/dam/racing/pdf/blucru2024/terms/2024_terms_UK_UK.pdf";

        switch (this.culture) {
            case "be-FR":
                termsAndCondition = "https://www.yamaha-racing.com/content/dam/racing/pdf/blucru2024/terms/2024_terms_BE_FR.pdf"
                break;
            case "be-NL":
                termsAndCondition = "https://www.yamaha-racing.com/content/dam/racing/pdf/blucru2024/terms/2024_terms_BE_NL.pdf"
                break;
            case "nl-NL":
                termsAndCondition = "https://www.yamaha-racing.com/content/dam/racing/pdf/blucru2024/terms/2024_terms_BE_NL.pdf";
                break;
            case "es-ES":
                termsAndCondition = "https://www.yamaha-racing.com/content/dam/racing/pdf/blucru2024/terms/2024_terms_ES_ES.pdf";
                break;
            case "fr-FR":
                termsAndCondition = "https://www.yamaha-racing.com/content/dam/racing/pdf/blucru2024/terms/2024_terms_FR_FR.pdf";
                break;
            case "it-IT":
                termsAndCondition = "https://www.yamaha-racing.com/content/dam/racing/pdf/blucru2024/terms/2024_terms_IT_IT.pdf";
                break;
            case "de-DE":
                termsAndCondition = "https://www.yamaha-racing.com/content/dam/racing/pdf/blucru2024/terms/2024_terms_DE_DE.pdf";
                break;
            case "sv-SE":
                termsAndCondition = "https://www.yamaha-racing.com/content/dam/racing/pdf/blucru2024/terms/2024_terms_SE_SE.pdf";
                break;
            case "da-DK":
                termsAndCondition = "https://www.yamaha-racing.com/content/dam/racing/pdf/blucru2024/terms/2024_terms_DK_DK.pdf";
                break;
            case "fi-FI":
                termsAndCondition = "https://www.yamaha-racing.com/content/dam/racing/pdf/blucru2024/terms/2024_terms_FI_FI.pdf";
                break;
            case "nn-NO":
                termsAndCondition = "https://www.yamaha-racing.com/content/dam/racing/pdf/blucru2024/terms/2024_terms_NO_NO.pdf";
                break;
            case "de-AT":
                termsAndCondition = "https://www.yamaha-racing.com/content/dam/racing/pdf/blucru2024/terms/2024_terms_DE_DE.pdf";
                break;
            case "fr-BE":
                termsAndCondition = "https://www.yamaha-racing.com/content/dam/racing/pdf/blucru2024/terms/2024_terms_BE_FR.pdf";
                break;
            case "nl-BE":
                termsAndCondition = "https://www.yamaha-racing.com/content/dam/racing/pdf/blucru2024/terms/2024_terms_BE_NL.pdf";
                break;
            case "it-CH":
                termsAndCondition = "https://www.yamaha-racing.com/content/dam/racing/pdf/blucru2024/terms/2024_terms_IT_IT.pdf";
                break;
            case "de-CH":
                termsAndCondition = "https://www.yamaha-racing.com/content/dam/racing/pdf/blucru2024/terms/2024_terms_DE_DE.pdf";
                break;
            case "fr-CH":
                termsAndCondition = "https://www.yamaha-racing.com/content/dam/racing/pdf/blucru2024/terms/2024_terms_FR_FR.pdf";
                break;
            case "hr-HR":
                termsAndCondition = "https://www.yamaha-racing.com/content/dam/racing/pdf/blucru2024/terms/2024_terms_HR_HR.pdf";
                break;
            case "el-GR":
                termsAndCondition = "https://www.yamaha-racing.com/content/dam/racing/pdf/blucru2024/terms/2024_terms_GR_GR.pdf";
                break;
            case "pt-PT":
                termsAndCondition = "https://www.yamaha-racing.com/content/dam/racing/pdf/blucru2024/terms/2024_terms_PT_PT.pdf";
                break;
            case "tr-TR":
                termsAndCondition = "https://www.yamaha-racing.com/content/dam/racing/pdf/blucru2024/terms/2024_terms_TR_TR.pdf";
                break;
            case "uk-UA":
                termsAndCondition = "https://www.yamaha-racing.com/content/dam/racing/pdf/blucru2024/terms/2024_terms_UK_UK.pdf";
                break;
        }

        return termsAndCondition;
    }

    public isValidationError(controlName: string): boolean {
        return FormHelper.isControlValidationError(controlName, this.validationErrors);
    }
};